var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('VideoComponentFs'),_c('fam-aseg'),_c('fam-bseg'),_c('fam-cseg'),_c('white-label'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }